import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import Link from './Link'

export default [
    { path: 'link', component: Link, beforeEnter: AdminGuard, name: 'link', meta: { title: 'Link' } }
]
